import { EventStrategyResolver } from './EventStrategies';
/**
 * TriggerEvent acts as a wrapper context for the event strategies
 */
var TriggerEvent = /** @class */ (function () {
    function TriggerEvent(context, props) {
        var _this = this;
        this.context = context;
        this.props = props;
        this.handleTriggerEvent = function (event) {
            var _a;
            (_a = _this.onChanged) === null || _a === void 0 ? void 0 : _a.call(_this, event);
        };
        var strategy = this.resolveStrategy();
        strategy.onEventTriggered = this.handleTriggerEvent;
        this.strategy = strategy;
    }
    TriggerEvent.prototype.start = function () {
        this.strategy.start();
    };
    TriggerEvent.prototype.resolveStrategy = function () {
        var resolver = new EventStrategyResolver();
        return resolver.resolveStrategyByEventType(this.context, this.props);
    };
    return TriggerEvent;
}());
export { TriggerEvent };
//# sourceMappingURL=TriggerEvent.js.map